// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"61":"6bb6b343","117":"a2826bae","377":"2329a462","394":"d6b07065","625":"135e6f08","662":"83d03fc8","746":"5ebdea53","912":"7dddeac1","960":"9c45457a","981":"f5279284"}[chunkId] + ".chunk.css";
};